export default __webpack_public_path__ + "static/lab_security_upgrade-756bcfb14e54a67186b218dce766d8ee.png";